// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--8857c";
export var accordionContent = "accordion-module--accordionContent--8f55d";
export var accordionOpen = "accordion-module--accordionOpen--7e6cb";
export var accordionTitle = "accordion-module--accordionTitle--7ceb9";